import { useTheme } from "@emotion/react";
import React from "react";
import { useWindowDimensions } from "react-native";
import { InlineRichText } from "../../components/RichText";
import placeholder from "./resources/placeHolder.png";
import imageUrl from "myplan/utils/imageUrl";
import { AppTheme } from "myplan/utils/theme";
import Pip from "../Pip";
import Text from "../Text";
import { NavigateNextIcon } from "myplan/components/Icon";
import { ArrowContainer, Body, Container, Thumbnail } from "./styles";

type StrategyListItemProps = {
    strategy: any;
    isNew?: boolean;
    onPress?: (strategyId: string) => void;
};

const StrategyListItem = ({
    strategy,
    isNew = true,
    onPress,
}: StrategyListItemProps) => {
    const {
        color: { enabled },
    }: AppTheme = useTheme() as AppTheme;
    const { title, titleRich, image } = strategy;
    const { width } = useWindowDimensions();
    const windowWidth = Math.floor(width);
    const img = imageUrl(image, placeholder);
    img.uri = `${img.uri}?w=${windowWidth}&fm=jpg`;

    const theTitle = titleRich ? <InlineRichText doc={titleRich} /> : title;

    return (
        <Container>
            <Body onPress={() => onPress?.(strategy._id)}>
                <Thumbnail source={img} />
                <Text type="body1" style={{ flex: 1, alignSelf: "flex-start" }}>
                    {theTitle}
                </Text>
                <ArrowContainer>
                    <NavigateNextIcon color={enabled} width="20" height="20" />
                </ArrowContainer>
                <Pip on={isNew} />
            </Body>
        </Container>
    );
};

export default StrategyListItem;
